









import { Component, Vue } from 'vue-property-decorator';

export default class App extends Vue {
    created() {
        console.log("main app. created...");
    }
}

